export const NIST_CSF_FUNCTIONS = [
  { code: "GV", name: "GOVERN", desc: "Organizational context, risk management strategy" },
  { code: "ID", name: "IDENTIFY", desc: "Asset management, risk assessment" },
  { code: "PR", name: "PROTECT", desc: "Access control, awareness, data security" },
  { code: "DE", name: "DETECT", desc: "Continuous monitoring, detection processes" },
  { code: "RS", name: "RESPOND", desc: "Response planning, communications, mitigation" },
  { code: "RC", name: "RECOVER", desc: "Recovery planning, improvements" },
];

export const NIST_CSF_CATALOG = [
  {
    function: "GOVERN (GV)",
    category: "Risk Management Strategy",
    subcategory: "GV.RM-01",
    description: "Risk management objectives are established and agreed upon.",
    implementationTier: "Tier 2–4",
    informativeReferences: "ISO 27001 Clauses 5–6",
    indianMapping: "RBI-RISK-01; CSCRF-RISK-01",
    technologyEnablers: "GRC platform",
  },
  {
    function: "PROTECT (PR)",
    category: "Identity Management",
    subcategory: "PR.AA-01",
    description: "Identities are managed and access is controlled.",
    implementationTier: "Tier 2–4",
    informativeReferences: "ISO 27001 A.5.15",
    indianMapping: "RBI-IAM-04; CSCRF-IAM-01",
    technologyEnablers: "IAM/IGA",
  },
  {
    function: "DETECT (DE)",
    category: "Security Continuous Monitoring",
    subcategory: "DE.CM-01",
    description: "Networks and systems are monitored to detect cybersecurity events.",
    implementationTier: "Tier 2–4",
    informativeReferences: "ISO 27001 A.8.16",
    indianMapping: "RBI-SOC-01; CERT-15",
    technologyEnablers: "SIEM/SOAR, NDR",
  },
];
